import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../components/Accessibility/PageTitle";
import { useHomeContext } from "../../../Store/contexts/HomeContext";
import { sxOptionTitle } from "./sxProps";
import './styles.css';
import { useEffect, useState } from "react";
import { ButtonsMenuItem } from "../../../interfaces/Home/ButtonsMenuItem";

function ButtonsMenu() {
	const navigate = useNavigate();
	const { menu } = useHomeContext();
	const location = useLocation();

	const [title, setTitle] = useState<string>('');
	const [buttons, setButtons] = useState<ButtonsMenuItem[]>([]);

	useEffect(() => {
		if (!menu) return;
		
		const items = menu
			.filter(menu => menu.children.length)
			.map(menu => menu.children)
			.flat()
			.filter(submenu => submenu.buttons.length)
			.filter(submenu => submenu.path === location.pathname);

		if (items && items.length && items[0].buttons.length) {
			const item = items[0];
			setTitle(item.subtitle || item.title);
			setButtons(item.buttons);
		}
	}, [menu, location.pathname]);

	const {
		contrastStyle,
		textStyleAccessibility,
		contrastBorderAccessibility,
	} = useAccessibility();

	if (!title || !buttons.length) {
		return <div></div>;
	}

	return (
		<div className="container">
			<PageTitle text={title} marginBottom="16px" />
			<div className="cancelamento-options-container" role="group" aria-label={`Grupo de botões ${buttons.length} itens`}>
				{
					buttons.map((item, index) => (
						<div
							key={`buttons-menu-${index}`}
							aria-label={`Botão ${index + 1} de ${buttons.length}`}
							style={{ ...contrastStyle, ...contrastBorderAccessibility }}
							className="cancelamento-option"
							tabIndex={0}
							onClick={() => {
								navigate(item.path);
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									navigate(item.path);
								}
							}}
						>
							<Typography
								style={textStyleAccessibility}
								sx={{ ...sxOptionTitle, marginRight: "20px" }}
							>
								{ item.title }
							</Typography>
							<FontAwesomeIcon icon={faChevronRight} />
						</div>
					))
				}
			</div>
		</div>
	);
}

export default ButtonsMenu;
